var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSaveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2095_1072)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.8799 3.25609L11.2439 0.620148C11.167 0.54323 11.0627 0.5 10.9539 0.5H10.0753H3.04607H1.50845C0.676703 0.5 0 1.1767 0 2.00847V12.9915C0 13.8233 0.676703 14.5 1.50845 14.5H3.04607H10.9539H12.4915C13.3233 14.5 14 13.8233 14 12.9915V3.54609C14 3.43732 13.9568 3.333 13.8799 3.25609ZM9.66511 1.32031V4.64438C9.66511 5.02383 9.3564 5.33254 8.97695 5.33254H4.14438C3.76493 5.33254 3.45622 5.02383 3.45622 4.64438V1.32031H9.66511ZM3.45622 13.6797V9.47695C3.45622 9.09753 3.76493 8.78882 4.14438 8.78882H9.85556C10.235 8.78882 10.5437 9.09753 10.5437 9.47695V13.6797H3.45622ZM13.1797 12.9915C13.1797 13.371 12.871 13.6797 12.4915 13.6797H11.3641V9.47695C11.3641 8.64521 10.6874 7.96851 9.85559 7.96851H4.14438C3.31261 7.96851 2.63591 8.64521 2.63591 9.47695V13.6797H1.50845C1.12902 13.6797 0.820312 13.371 0.820312 12.9915V2.00847C0.820312 1.62902 1.12902 1.32031 1.50845 1.32031H2.63591V4.64438C2.63591 5.47615 3.31261 6.15286 4.14438 6.15286H8.97695C9.80872 6.15286 10.4854 5.47615 10.4854 4.64438V1.32031H10.784L13.1797 3.71601V12.9915Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.31799 4.39561C8.54451 4.39561 8.72815 4.21196 8.72815 3.98545V2.66748C8.72815 2.44096 8.54451 2.25732 8.31799 2.25732C8.09148 2.25732 7.90784 2.44096 7.90784 2.66748V3.98545C7.90784 4.21196 8.09148 4.39561 8.31799 4.39561Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2095_1072"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaveIcon);
export default __webpack_public_path__ + "static/media/saveIcon.ed8ca1896b30e7f8ac1d4a0879e08655.svg";
export { ForwardRef as ReactComponent };